import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm } from "@inertiajs/inertia-react";
import PageHeading from "@/Components/PageHeading";
import LoadingButton from "@/Components/LoadingButton";
import { Inertia } from "@inertiajs/inertia";
import FileInput from "@/Components/FileInput";
import Label from "@/Components/Label";
import SwitchInput from "@/Components/SwitchInput";

const Import = () => {
    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Fee", route: route("fees") },
        { name: "Import", route: null },
    ];

    const { data, setData, errors, post, processing } = useForm({
        importFile: null,
        sendSms: false,
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("fees.import"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("fees"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Import Fee"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label
                                    label={"Upload File"}
                                    name={"importFile"}
                                />
                                <FileInput
                                    name={"importFile"}
                                    accept={".xlsx"}
                                    errors={errors.importFile}
                                    value={data.importFile}
                                    onChange={(file) =>
                                        setData("importFile", file)
                                    }
                                />
                            </div>
                            <div>
                                <SwitchInput
                                    label={"Send SMS Notification"}
                                    description={
                                        "Enabling this option will send the SMS to all the students currently being uploaded with fee greater than 0"
                                    }
                                    enabled={data.sendSms}
                                    setEnabled={(e) => setData("sendSms", e)}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={
                                        "bg-gray-500 font-medium text-white"
                                    }
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={
                                        "bg-indigo-600 font-medium text-white hover:bg-indigo-700 focus:ring-indigo-500"
                                    }
                                >
                                    Import
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        // <div
        //     id="main-content"
        //     className="relative h-full w-full overflow-y-auto"
        // >
        //     <main>
        //         <div className="block items-center justify-between border-b border-gray-200 bg-white p-4 sm:flex">
        //             <div className="mb-1 w-full">
        //                 <div className="mb-4">
        //                     <BreadCrumb
        //                         links={[
        //                             { name: "Home", route: "dashboard" },
        //                             { name: "Fees", route: "fees" },
        //                             { name: "Import", route: null },
        //                         ]}
        //                     />
        //                     <h1 className="text-xl font-semibold text-gray-900 sm:text-2xl">
        //                         Fees
        //                     </h1>
        //                 </div>
        //                 <div className="sm:flex">
        //                     <div className="mr-auto flex items-center space-x-2 sm:space-x-3">
        //                         <Link
        //                             className={
        //                                 "inline-flex w-1/2 items-center justify-center rounded-lg border border-gray-300 bg-white px-3 py-2 text-center text-sm font-medium text-gray-900 hover:bg-gray-100 focus:ring-4 focus:ring-cyan-200 sm:w-auto"
        //                             }
        //                             href={route("fees")}
        //                         >
        //                             <svg
        //                                 xmlns="http://www.w3.org/2000/svg"
        //                                 className="-ml-1 mr-2 h-6 w-6"
        //                                 viewBox="0 0 20 20"
        //                                 fill="currentColor"
        //                             >
        //                                 <path
        //                                     fillRule="evenodd"
        //                                     d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
        //                                     clipRule="evenodd"
        //                                 />
        //                             </svg>
        //                             Back
        //                         </Link>
        //                     </div>
        //                     <div className="ml-auto flex items-center space-x-2 sm:space-x-3"></div>
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="flex items-center justify-center border-b border-gray-200 p-4">
        //             <div className="w-1/3 p-6">
        //                 <form onSubmit={handleSubmit}>
        //                     <div className="-mb-8 -mr-6 flex flex-wrap p-8">
        //                         <div className="mb-6">
        //                             <Label
        //                                 label={"Upload File"}
        //                                 name={"importFile"}
        //                             />
        //                             <FileInput
        //                                 className={"w-full pb-8 pr-6 lg:w-1/2"}
        //                                 label={"Import File"}
        //                                 name={"importFile"}
        //                                 accept={".xlsx"}
        //                                 errors={errors.importFile}
        //                                 value={data.importFile}
        //                                 onChange={(file) =>
        //                                     setData("importFile", file)
        //                                 }
        //                             />
        //                             <progress
        //                                 className="w-full pb-8 pr-6 lg:w-full"
        //                                 value={processing.percentage}
        //                                 max={"100"}
        //                             >
        //                                 {processing.percentage}%
        //                             </progress>
        //                         </div>
        //                     </div>
        //                     <div className="mt-4 flex items-center justify-end">
        //                         <LoadingButton
        //                             loading={processing}
        //                             type={"submit"}
        //                             className={"btn-primary"}
        //                         >
        //                             Upload Fees
        //                         </LoadingButton>
        //                     </div>
        //                 </form>
        //             </div>
        //         </div>
        //     </main>
        // </div>
    );
};

Import.layout = (page) => (
    <Authenticated title={"Import Fees"} children={page} />
);

export default Import;
